export default __webpack_public_path__ + "static/media/ofs_800_sal.582b0d99.jpg";